// extracted by mini-css-extract-plugin
export var eventsWrapper = "DesktopContent-module--eventsWrapper--22494";
export var hidden = "DesktopContent-module--hidden--a2c86";
export var buttonsRow = "DesktopContent-module--buttonsRow--67a5e";
export var seeMoreButton = "DesktopContent-module--seeMoreButton--1c352";
export var hideAllButton = "DesktopContent-module--hideAllButton--c5a96";